module.exports = __webpack_public_path__ + "img/tuling-white.3bb4aa51.png";